<!--
 * @Author: liushengjiang 1947448287@qq.com
 * @Date: 2021-12-28 15:26:11
 * @LastEditors: liushengjiang 1947448287@qq.com
 * @LastEditTime: 2023-12-20 11:30:11
 * @FilePath: \petro-web-chemicals-buyerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\views\messageDetail\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="message-detail">
    <Header title="资讯详情" :is-nav="true"></Header>
    <div class="message-scroll">
      <MessageContent :message="message"></MessageContent>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import MessageContent from "./components/Content";
import contentApi from "@/request/contentApi";
export default {
  name: "MessageDetail",
  components: {
    Header,
    MessageContent,
  },
  // props: {
  //   id: String,
  // },
  data() {
    return {
      title: "",
      headerTitle: this.$route.query.headerTitle,
      message: {},
    };
  },
  mounted() {
    this.getMessage();
    // this.headerTitle = this.$route.query.headerTitle;
  },
  methods: {
    getMessage() {
      let params = {
        id: this.$route.query.id,
      };
      contentApi.getInformationDetail(params).then((res) => {
        if (res.returnCode == "0") {
          this.message = res.result;
          let data = JSON.parse(this.message.otherFilePath);
          let dataTwo = [];
          for(let key in data) {
            let item = {};
            item.name = key;
            item.value = data[key];
            dataTwo.push(item);
            this.message.otherFilePath = dataTwo;
            console.log(dataTwo);
          }
          console.log(6666,data);
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
  },
};
</script>

<style lang='stylus' scoped>
.message-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  overflow: hidden;

  .message-scroll {
    flex: 1;
    overflow: auto;

  }
}
</style>
